export default "__VITE_ASSET__CI3k7C_7__"